import React from 'react';

interface Props {
  children: any;
  required?: boolean;
}

export default (props: Props) => (
  <span className="fake-label">
    {props.children}
    {props.required && <span className="required-asterisk">*</span>}
  </span>
);
